/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Pit1_TInputs */

const en_diff_pit1_t = /** @type {(inputs: Diff_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reordering a list looks like a rewrite`)
};

const ko_diff_pit1_t = /** @type {(inputs: Diff_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`목록 순서를 바꾸면 전면 수정처럼 보입니다`)
};

const ja_diff_pit1_t = /** @type {(inputs: Diff_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リストの順序を変えると全面書き換えのように見えます`)
};

/**
* | output |
* | --- |
* | "Reordering a list looks like a rewrite" |
*
* @param {Diff_Pit1_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_pit1_t = /** @type {((inputs?: Diff_Pit1_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Pit1_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_pit1_t(inputs)
	if (locale === "ko") return ko_diff_pit1_t(inputs)
	return ja_diff_pit1_t(inputs)
});